import { ChangeDetectorRef, Directive, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { APPEND_BUTTON_PASSWORD_STATE } from '@common/constants';
import { InputComponent } from 'mbs-ui-kit';

@Directive({
  selector: 'mbs-input[mbsPasswordToggle]'
})
export class PasswordToggleDirective {
  private readonly input = inject(InputComponent);
  private readonly cdRef = inject(ChangeDetectorRef);

  private visible = false;

  constructor() {
    // 'off' is ignored by browsers on password fields and the saved password gets autofilled
    this.input.autocomplete = 'new-password';
    this.render();
    this.input.buttonClick.pipe(takeUntilDestroyed()).subscribe(() => this.toggle());
  }

  private toggle(): void {
    this.visible = !this.visible;
    this.render();
  }

  private render(): void {
    const state = this.visible ? APPEND_BUTTON_PASSWORD_STATE.visible : APPEND_BUTTON_PASSWORD_STATE.hidden;

    this.input.type = state.type;
    this.input.appendButtons = [{ type: 'secondary', icon: state.icon, btnType: 'button' }];
    this.cdRef.markForCheck();
  }
}
